import { useEffect, useMemo, useRef } from 'react';
import { MapCompanyRole } from '@/creditflowresearch/application/League/constants';

interface IParams {
  hasAccess: boolean,
  leagueType: string | string[],
  productIds: string[],
  regionIds: string[],
  products: string | string[] | undefined,
  regions: string | string[] | undefined,
  getPageData: (args: { productIds: string[], regionIds: string[], companyRole: string }) => void,
}

export const useFetchStandings = ({
  hasAccess,
  leagueType,
  productIds,
  regionIds,
  products,
  regions,
  getPageData,
}: IParams) => {
  const didMount = useRef(false);

  const companyRole = useMemo(() => {
    const valueLeagueType = Array.isArray(leagueType) ? leagueType[0] : leagueType;
    return MapCompanyRole[valueLeagueType];
  }, [leagueType]);

  useEffect(() => {
    if (hasAccess && didMount.current) {
      getPageData({ productIds, regionIds, companyRole });
    } else if (hasAccess) {
      didMount.current = true;
    }
  }, [products, regions, leagueType, hasAccess]);
};
